import { render, staticRenderFns } from "./GlobalSearchField.vue?vue&type=template&id=4b3333ef&scoped=true&"
import script from "./GlobalSearchField.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchField.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchField.vue?vue&type=style&index=0&id=4b3333ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3333ef",
  null
  
)

export default component.exports